import { render, staticRenderFns } from "./GeneralProductInfo.vue?vue&type=template&id=ba799aa4"
import script from "./GeneralProductInfo.vue?vue&type=script&lang=js"
export * from "./GeneralProductInfo.vue?vue&type=script&lang=js"
import style0 from "./GeneralProductInfo.vue?vue&type=style&index=0&id=ba799aa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports